import { isEqual } from 'lodash';

export function oncePerArgs<
  T extends (...args: Parameters<T>) => ReturnType<T>,
>(fn: T): T & { reset: () => void } {
  let lastArgs: Parameters<T> | undefined;
  let hasRun = false;

  const wrapper = (...args: Parameters<T>): ReturnType<T> | undefined => {
    if (!hasRun || !isEqual(args, lastArgs)) {
      lastArgs = args;
      hasRun = true;
      return fn(...args);
    }
    return undefined;
  };

  (wrapper as typeof wrapper & { reset: () => void }).reset = () => {
    hasRun = false;
    lastArgs = undefined;
  };

  return wrapper as T & { reset: () => void };
}
